module.exports = __webpack_public_path__ + "static/media/webdesign-services-img36.0f8f060b.jpg";